export default __webpack_public_path__ + "static/bannerAccountToaccountPageBg-d03d5dc24d9e6f1d14f31f61f3fc5efd.png";